import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';

import MDBox from 'components/MDBox';
import PageLayout from 'examples/LayoutContainers/PageLayout';
import AuthFooter from '../pages/components/AuthFooter';

export function AuthBasicLayout({ image, children, footerVariant = 'light' }) {
  return (
    <PageLayout>
      {/* Background layer */}
      <MDBox
        position="fixed"
        top={0}
        left={0}
        width="100%"
        height="100%"
        sx={{
          zIndex: 0,
          backgroundImage: image ? `url(${image})` : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          transform: 'scale(1.02)', // hafif zoom -> daha premium, edge flicker azalır
        }}
      />

      {/* Overlay: gradient + vignette */}
      <MDBox
        position="fixed"
        top={0}
        left={0}
        width="100%"
        height="100%"
        sx={{
          zIndex: 0,
          pointerEvents: 'none',
          backgroundImage: ({
            functions: { linearGradient, rgba },
            palette: { gradients, dark },
          }) => {
            // 1) ana koyu gradient
            const g1 = linearGradient(
              rgba(gradients.dark.main, 0.72),
              rgba(gradients.dark.state, 0.64)
            );

            // 2) vignette (kenarlar koyu, orta açık)
            const vignette = `radial-gradient(1200px 800px at 35% 25%, ${rgba(
              dark.main,
              0.15
            )} 0%, ${rgba(dark.main, 0.55)} 55%, ${rgba(dark.main, 0.82)} 100%)`;

            return `${vignette}, ${g1}`;
          },
        }}
      />

      {/* Subtle noise layer (banding azaltır) */}
      <MDBox
        position="fixed"
        top={0}
        left={0}
        width="100%"
        height="100%"
        sx={{
          zIndex: 0,
          pointerEvents: 'none',
          opacity: 0.06,
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='160' height='160' filter='url(%23n)' opacity='.35'/%3E%3C/svg%3E\")",
        }}
      />

      {/* Content wrapper */}
      <MDBox
        minHeight="100vh"
        display="flex"
        flexDirection="column"
        sx={{
          position: 'relative',
          zIndex: 1,
          px: { xs: 2, sm: 2.5 },
          py: { xs: 2.5, sm: 3 },
        }}
      >
        {/* Center area */}
        <MDBox
          flex={1}
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ pb: { xs: 2, sm: 2.5 } }}
        >
          <Grid container justifyContent="center">
            {/* ✅ login (480) ve signup (640) ikisi de rahat sığsın */}
            <Grid
              item
              xs={12}
              sm={10}
              md={7}
              lg={6}
              xl={4.2}
              sx={{ display: 'flex', justifyContent: 'center' }}
            >
              {children}
            </Grid>
          </Grid>
        </MDBox>

        {/* Footer always flow, never overlap */}
        <MDBox sx={{ mt: 'auto' }}>
          <AuthFooter light={footerVariant === 'light'} />
        </MDBox>
      </MDBox>
    </PageLayout>
  );
}

AuthBasicLayout.propTypes = {
  image: PropTypes.string,
  children: PropTypes.node.isRequired,
  footerVariant: PropTypes.oneOf(['light', 'dark']),
};
